import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEscapeKey } from '../hooks/useEscapeKey';

export default function StreakAtRiskModal({ habit, onClose, onCheckin }) {
  const navigate = useNavigate();
  useEscapeKey(onClose);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-white dark:bg-gray-800 rounded-2xl p-6 text-center animate-scale-in" role="dialog" aria-modal="true">
        <div className="text-4xl mb-3">⚠️</div>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
          Streak at Risk!
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mb-6">
          Your <strong className="text-orange-500">{habit.currentStreak}-day</strong> streak
          for <strong>{habit.icon} {habit.name}</strong> is at risk! Don't lose your progress.
        </p>

        {/* Primary = the free, actually-helpful action. */}
        <button
          onClick={() => {
            onCheckin();
            onClose();
          }}
          className="w-full py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-colors mb-2"
        >
          Check in now
        </button>

        <button
          onClick={() => {
            onClose();
            navigate('/premium?source=streak_risk');
          }}
          className="w-full py-3 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white font-semibold rounded-xl hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors mb-2"
        >
          🧊 Protect with Streak Freeze (Premium)
        </button>

        <button
          onClick={onClose}
          className="text-sm text-gray-500 dark:text-gray-400"
        >
          I'll handle it
        </button>
      </div>
    </div>
  );
}
